export const COL_CHECKBOX = "colCheckbox";
export const DEFAULT_COLUMN_WIDTH = 300;

export const getTableDefaultValue = ({ t, showDefaultColumnName }) => {
  const columnHeaderNames = {
    1: showDefaultColumnName
      ? t("project:action")
      : t("project:column_number", { number: 1 }),
    2: showDefaultColumnName
      ? t("project:comments_or_reflection")
      : t("project:column_number", { number: 2 }),
    3: showDefaultColumnName
      ? t("project:deadline")
      : t("project:column_number", { number: 3 }),
  };

  return {
    columns: [
      {
        accessorKey: COL_CHECKBOX,
        id: "1",
        isFixed: true,
        size: 48,
        maxSize: 48,
      },
      {
        accessorKey: `col1`,
        id: "2",
        size: DEFAULT_COLUMN_WIDTH,
      },
      {
        accessorKey: `col2`,
        id: "3",
        size: DEFAULT_COLUMN_WIDTH,
      },
      {
        accessorKey: `col3`,
        id: "4",
        size: DEFAULT_COLUMN_WIDTH,
      },
    ],
    data: [
      {
        id: 1,
        [COL_CHECKBOX]: null,
        col1: columnHeaderNames[1],
        col2: columnHeaderNames[2],
        col3: columnHeaderNames[3],
        isFixed: true,
        isHeader: true,
      },
      {
        id: 2,
        [COL_CHECKBOX]: false,
        col1: "",
        col2: "",
        col3: "",
      },
      {
        id: 3,
        [COL_CHECKBOX]: false,
        col1: "",
        col2: "",
        col3: "",
      },
      {
        id: 4,
        [COL_CHECKBOX]: false,
        col1: "",
        col2: "",
        col3: "",
      },
    ],
  };
};
